import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col,Table } from 'react-bootstrap';

// app
import config from '../../config';
import * as runActions from '../../actions/runsActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as groupActions from '../../actions/groupActionCreators';
import * as commonActions from '../../actions/commonActions';

import StudentPage from './StudentPage';
import AddDropStudentPage from './AddDropStudentPage';
import label from '../../utils/lngEn';
import AddGroupModal from './AddGroupModal';
import AddReleaseModal from './AddReleaseModal';


class StudentPageContainer extends React.Component {
  state = {
    readyForDisplay: false,
    showAddGroupModal: false,
    groupsModalValues: {
      title: '',
      initialValues: {}
    },

    showReleaseModal: false,
    releaseModalValues: {
      title: '',
      studentId: '',

      initialValues: {}
    },
    overridesList: []
  };

  componentDidMount() {
    const { run, runActions } = this.props;
    if (run.id) return this.setState({ readyForDisplay: true });
    runActions
      .getRun()
      .then(() => this.setState({ readyForDisplay: true }))
  }

  componentWillMount() {
    if (this.props.studentId) {
      this.props.groupActions.getAllGroups();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.studentId && nextProps.student.overrides != this.props.student.overrides) {
      this.setOverridesToState(nextProps.student.overrides);
    }
  }

  // Group Modal
  openGroupsModal = () => {
    this.setState({
      showAddGroupModal: true,
      groupsModalValues: {
        title: `${label.addStudentToGroups}`,
        classId: this.props.classId,
        initialValues: {}
      }
    });
  }

  
  // Release Modal
  openAddReleaseModal = () => {
    this.setState({
      showReleaseModal: true,
      releaseModalValues: {
        title: `${label.createReleaseModalTitle}`,
        studentId: this.props.studentId,

        initialValues: {}
      }
    });
  }

  closeAddGroupsModal = () => {
    this.setState({ showAddGroupModal: false });
  }

  closeAddReleaseModal = () => {
    this.setState({ showReleaseModal: false });
  }

  getGroupName = (groupId) => {
    let group = this.props.groups.filter(function(group) {
      return group.id == groupId;
    });
    let name = group.map(function(g) {
      return g.name;
    });
    return name;
  }

  setOverridesToState(overrides) {
    let overridesList = [];
    if (overrides.run_lock_overrides.length > 0) {
      overrides.run_lock_overrides.map(override => {
        let obj = {};
        obj.overrideId = override.id;
        obj.typeTitle = label.run_lock;
        obj.type = config.run_locks;
        obj.id = override.run_lock.id;
        obj.name = 'Class - ' + commonActions.getCourseName(override.run_lock.course, this.props.courses);
        overridesList.push(obj);
      });
    }
    if (overrides.run_conflict_overrides.length > 0) {
      overrides.run_conflict_overrides.map(override => {
        let obj = {};
        obj.overrideId = override.id;
        obj.typeTitle = label.run_conflict;
        obj.type = config.run_conflicts;
        obj.id = override.run_conflict.id;
        obj.name = override.run_conflict.name;
        obj.courses = override.run_conflict.courses;
        overridesList.push(obj);
      });
    }
    if (overrides.run_requirement_overrides.length > 0) {
      overrides.run_requirement_overrides.map(override => {
        let obj = {};
        obj.overrideId = override.id;
        obj.id = override.run_requirement.id;
        obj.typeTitle = label.run_requirement;
        obj.type = config.run_requirements;
        obj.name = override.run_requirement.name;
        obj.courses = override.run_requirement.courses;
        overridesList.push(obj);
      });
    }
    if (overrides.group_lock_overrides.length > 0) {
      overrides.group_lock_overrides.map(override => {
        let obj = {};
        obj.overrideId = override.id;
        obj.id = override.student_group_lock.id;
        obj.typeTitle = label.group_lock;
        obj.type = config.group_locks;
        obj.name = 'Class - ' + commonActions.getCourseName(override.student_group_lock.course, this.props.courses);
        overridesList.push(obj);
      });
    }
    if (overrides.group_conflict_overrides.length > 0) {
      overrides.group_conflict_overrides.map(override => {
        let obj = {};
        obj.overrideId = override.id;
        obj.id = override.student_group_conflict.id;
        obj.typeTitle = label.group_conflict;
        obj.type = config.group_conflicts;
        obj.name = override.student_group_conflict.name;
        obj.courses = override.student_group_conflict.courses;
        overridesList.push(obj);
      });
    }
    if (overrides.group_requirement_overrides.length > 0) {
      overrides.group_requirement_overrides.map(override => {
        let obj = {};
        obj.overrideId = override.id;
        obj.id = override.student_group_requirement.id;
        obj.typeTitle = label.group_requirement;
        obj.type = config.group_requirements;
        obj.name = override.student_group_requirement.name;
        obj.courses = override.student_group_requirement.courses;
        overridesList.push(obj);
      });
    }
    this.setState({ overridesList: overridesList });
  }

  
  handleDeleteMembership = (id) => {
    this.props.groupActions.deleteMembership(id).then(() => {
      this.props.studentActions.getStudentById(this.props.student.id);
      this.props.studentActions.getAllStudents();
    });
  }

  handleDeleteRelease(id, type, studentId) {
    this.props.studentActions.deleteOverride(id, type, studentId);
  }

  renderStudentGroups = () => {
    const { student, groups, studentId } = this.props;
    const { memberships = [] } = student;

    return (
      <div>
        <div className="page-subtitle">Groups</div>
        <Row className="mb-2 mt-n-2">
          <Col md={12}>
            <button
              onClick={this.openGroupsModal}
              className="btn btn-ter"
              disabled={memberships.length == groups.length}
            >
              {label.addStudentToGroups}
            </button>
          </Col>
        </Row>

        { memberships.length > 0 && groups.length > 0 && (
          <div className="conflict-row">
            <div className="conflict-name">
              <div className="name">
                <span className="no-span-links">Student is a member of:</span>
              </div>
            </div>
            <div className="conflict-courses">
              {memberships.map((mem, index) => {
                return (
                  <div key={index} className="conflict-course">
                    <span className="no-span-links">{this.getGroupName(mem.group)}</span>
                    <span className="ml-1">
                      <i
                        className="fa fa-minus-circle"
                        onClick={() => {
                          this.handleDeleteMembership(mem.id);
                        }}
                      />
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {studentId && (
          <AddGroupModal
            closeModal={this.closeAddGroupsModal}
            showModal={this.state.showAddGroupModal}
            onCancel={this.closeAddGroupsModal}
            initial={this.state.groupsModalValues}
          />
        )}
      </div>
    );
  }

  renderRestrictionReleases = () => (
    <div>
      <div className="page-subtitle">Restriction Releases</div>

      <Row className="mt-4 mb-2">
        <Col md={12}>
          <button
            onClick={this.openAddReleaseModal}
            className="btn btn-ter"
          >
            Release Restrictions
          </button>
        </Col>
      </Row>
      {this.state.overridesList.length > 0 ? (
        <div className="c-table classes-table mt-2">
          <Table condensed hover>
            <thead>
              <tr>
                <th>Release Type</th>
                <th>Restriction Name</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {this.state.overridesList.map((override, index) => {
                return (
                  <tr key={index}>
                    <td className="class-desc">{override.typeTitle}</td>
                    <td className="class-desc">{override.name}</td>
                    <td className="class-edit">
                      <span
                        onClick={() => {
                          this.handleDeleteRelease(
                            override.overrideId,
                            override.type,
                            this.props.studentId
                          );
                        }}
                      >
                        Delete
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      ) : null}

      {this.props.studentId && (
        <AddReleaseModal
          closeModal={this.closeAddReleaseModal}
          showModal={this.state.showReleaseModal}
          onCancel={this.closeAddReleaseModal}
          initial={this.state.releaseModalValues}
          overridesList={this.state.overridesList}
        />
      )}
    </div>
  );

  render() {
    const { run } = this.props;
    const { readyForDisplay } = this.state;
    const { assignment_complete } = run;

    const commonComponents = {
      StudentGroups: this.props.studentId && this.props.student && this.props.student.id && this.renderStudentGroups(),
      RestrictionReleases: this.renderRestrictionReleases()
    };

    if (!readyForDisplay) return null;
    if (assignment_complete) return <AddDropStudentPage  {...this.props} commonComponents={commonComponents}/>;
    return <StudentPage {...this.props} commonComponents={commonComponents}/>;
  }
}

const mapStateToProps = (state, ownProps) => {
  let studentId = null;

  if (ownProps.params.id) {
    studentId = ownProps.params.id;
  }
  return {
    run: state.run,
    student: state.student,
    groups: state.groups,
    studentId
  }
}

const mapDispatchToProps = (dispatch) => ({
  runActions: bindActionCreators(runActions, dispatch),
  studentActions: bindActionCreators(studentActions, dispatch),
  groupActions: bindActionCreators(groupActions, dispatch),
  commonActions: bindActionCreators(commonActions, dispatch)
});

StudentPageContainer.defaultProps = {
  run: {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentPageContainer);



// WEBPACK FOOTER //
// ./src/components/students/StudentPageContainer.js